<div class="advanced-settings">
  <div class="content">
    <div class="tabs-setting" *ngIf="validSubscription">
      <a routerLink="/advanced-settings/super-seller" routerLinkActive="active">overview</a>
      <a routerLink="/advanced-settings/super-seller-setting" routerLinkActive="active">edit</a>
    </div>
    <div class="header">
      <div class="text-left">
        <h2>SUBSCRIPTIONS</h2>
        <div class="desc">Select a subscription plan that fits your needs. You can cancel anytime.</div>
      </div>

      <button class="my-button-3" (click)="handleManageSubscription()">Manage Subscriptions</button>
    </div>

    <div class="current-plan" *ngIf="currentSubscription">
      <div class="plan-details">
        <h3>Current Plan</h3>
        <div class="plan-info">
          <div class="plan-name">{{currentSubscription.productName}}</div>
          <div class="plan-price">${{currentSubscription.productPrice}} / month</div>
          <div class="plan-status">
            <span>
              {{currentSubscription.status}}
            </span>
          </div>
        </div>
        <div class="renewal-info" *ngIf="currentSubscription.expiresAt">
          Next billing date: {{currentSubscription.expiresAt | date:'MMM d, yyyy'}}
        </div>
      </div>
    </div>

    <div class="my-grid">
      <div class="my-card space-b">
        <div>
          <svg viewBox="0 0 1269 801" fill="none">
            <path
              d="M480.924 549.558C491.226 559.189 491.77 575.347 482.14 585.649C472.509 595.951 456.35 596.495 446.049 586.864C435.747 577.234 435.202 561.075 444.833 550.773C454.464 540.471 470.622 539.927 480.924 549.558Z"
              fill="#518FDA" stroke="white" stroke-width="3" />
            <path
              d="M512.477 620.266V620.266V628.631V679.525C512.477 684.171 508.712 687.936 504.067 687.936C499.422 687.936 495.657 684.171 495.657 679.525V630.448C495.657 628.616 494.172 627.131 492.34 627.131C490.507 627.131 489.022 628.616 489.022 630.448V695.782V704.02V774.337C489.022 780.375 484.128 785.27 478.089 785.27C472.051 785.27 467.156 780.375 467.156 774.337V706.187C467.156 704.162 465.514 702.52 463.489 702.52C461.464 702.52 459.822 704.162 459.822 706.187V774.337C459.822 780.375 454.927 785.27 448.888 785.27C442.85 785.27 437.955 780.375 437.955 774.337V704.02V695.782V630.448C437.955 628.616 436.47 627.131 434.638 627.131C432.806 627.131 431.321 628.616 431.321 630.448V679.525C431.321 684.171 427.556 687.936 422.91 687.936C418.265 687.936 414.5 684.171 414.5 679.525V628.631V620.266C414.5 610.148 422.703 601.945 432.821 601.945H436.455H490.524H494.158C504.277 601.945 512.479 610.148 512.477 620.266Z"
              fill="#518FDA" stroke="white" stroke-width="3" />
            <line x1="1269" y1="796" x2="4.37114e-07" y2="796" stroke="#3E4D57" stroke-width="10" />
            <path d="M1017 734C1017 731.239 1019.24 729 1022 729H1068C1070.76 729 1073 731.239 1073 734V798H1017V734Z"
              fill="#3E4D57" />
            <path d="M1027 741C1027 738.239 1029.24 736 1032 736H1058C1060.76 736 1063 738.239 1063 741V791H1027V741Z"
              fill="#F1C858" />
            <path
              d="M1117.99 627.643C1118.44 644.746 1104.55 659.898 1097.55 665.337C1081.19 677.939 1052.87 680.339 1040.76 679.964C1009.53 679.964 999.872 673.213 986.243 665.337C974.886 655.772 971 641.707 971 631.018C971 614.703 979.997 602.326 993.626 594.449C1008.66 585.759 1007.82 574.832 1006.69 560.767C1005.34 544.16 1024.86 523 1053.82 523C1080.62 523 1088.84 542.128 1090.73 551.692C1092.43 578.134 1094.48 579.324 1103.22 591.074C1111.17 601.763 1117.42 606.264 1117.99 627.643Z"
              fill="#3E4D57" />
            <path
              d="M1110 627C1110.4 642.2 1098.17 655.667 1092 660.5C1077.6 671.7 1052.67 673.833 1042 673.5C1014.5 673.5 1006 667.5 993.999 660.5C984 652 980.578 639.5 980.578 630C980.578 615.5 988.5 604.5 1000.5 597.5C1013.74 589.776 1013 580.065 1012 567.565C1010.82 552.806 1028 534 1053.5 534C1077.1 534 1084.33 551 1086 559.5C1087.5 583 1089.3 584.057 1097 594.5C1104 604 1109.5 608 1110 627Z"
              fill="#0EB39B" />
            <circle cx="1089" cy="435" r="12" fill="#3E4D57" />
            <circle cx="1098" cy="479" r="12" fill="#3E4D57" />
            <circle cx="1098" cy="526" r="12" fill="#3E4D57" />
            <circle cx="1065" cy="395" r="12" fill="#3E4D57" />
            <circle cx="1033" cy="359" r="12" fill="#3E4D57" />
            <circle cx="993" cy="335" r="12" fill="#3E4D57" />
            <circle cx="949" cy="323" r="12" fill="#3E4D57" />
            <circle cx="782.999" cy="596.131" r="12" transform="rotate(159.275 782.999 596.131)" fill="#3E4D57" />
            <circle cx="759.01" cy="558.163" r="12" transform="rotate(159.275 759.01 558.163)" fill="#3E4D57" />
            <circle cx="742.378" cy="514.204" r="12" transform="rotate(159.275 742.378 514.204)" fill="#3E4D57" />
            <circle cx="819.602" cy="625.049" r="12" transform="rotate(159.275 819.602 625.049)" fill="#3E4D57" />
            <circle cx="862.271" cy="647.395" r="12" transform="rotate(159.275 862.271 647.395)" fill="#3E4D57" />
            <circle cx="908.176" cy="655.686" r="12" transform="rotate(159.275 908.176 655.686)" fill="#3E4D57" />
            <circle cx="953.575" cy="651.338" r="12" transform="rotate(159.275 953.575 651.338)" fill="#3E4D57" />
            <circle cx="815.311" cy="352.092" r="12" transform="rotate(-104.483 815.311 352.092)" fill="#3E4D57" />
            <circle cx="855.663" cy="332.374" r="12" transform="rotate(-104.483 855.663 332.374)" fill="#3E4D57" />
            <circle cx="901.169" cy="320.62" r="12" transform="rotate(-104.483 901.169 320.62)" fill="#3E4D57" />
            <circle cx="782.585" cy="385.333" r="12" transform="rotate(-104.483 782.585 385.333)" fill="#3E4D57" />
            <circle cx="755.732" cy="425.319" r="12" transform="rotate(-104.483 755.732 425.319)" fill="#3E4D57" />
            <circle cx="742.498" cy="470.05" r="12" transform="rotate(-104.483 742.498 470.05)" fill="#3E4D57" />
            <path d="M35 0H284V24H159.5H35V0Z" fill="black" fill-opacity="0.22" />
            <rect x="101" y="28" width="157" height="24" fill="black" fill-opacity="0.26" />
            <rect x="77" y="56" width="249" height="24" fill="black" fill-opacity="0.25" />
            <path
              d="M583.908 631.74C595.986 631.74 605.778 621.948 605.778 609.87C605.778 597.792 595.986 588 583.908 588C571.829 588 562.038 597.792 562.038 609.87C562.038 621.948 571.829 631.74 583.908 631.74Z"
              fill="white" stroke="white" stroke-width="2.5" stroke-miterlimit="10" />
            <path
              d="M604.871 672.572C604.905 672.552 604.892 672.56 604.926 672.54C608.257 679.307 614.685 692.366 618.702 700.527C620.656 704.496 625.456 706.126 629.425 704.172L629.431 704.169C633.403 702.214 635.039 697.408 633.083 693.435L614.9 656.496L608.723 643.828C606.367 638.996 601.462 635.931 596.086 635.931H583.47H583.439H570.823C565.447 635.931 560.542 638.996 558.186 643.828L552.009 656.496L533.826 693.435C531.871 697.408 533.506 702.213 537.478 704.169L537.484 704.172C541.453 706.126 546.253 704.496 548.207 700.527C552.224 692.366 558.652 679.307 561.983 672.54C562.017 672.56 562.004 672.552 562.038 672.572L545.631 724.692C543.706 729.084 546.923 734.007 551.719 734.007H560.907C561.531 734.007 562.038 734.513 562.038 735.138V776.603C562.038 782.158 566.541 786.661 572.096 786.661C577.651 786.661 582.154 782.158 582.154 776.603V734.849C582.154 734.384 582.531 734.008 582.995 734.008H583.914C584.379 734.008 584.755 734.385 584.755 734.849V776.603C584.755 782.158 589.258 786.661 594.813 786.661C600.368 786.661 604.871 782.158 604.871 776.603V735.138C604.871 734.514 605.377 734.007 606.002 734.007H615.19C619.985 734.007 623.203 729.084 621.278 724.692L604.871 672.572Z"
              fill="white" stroke="white" stroke-width="2.5" stroke-miterlimit="10" />
            <path
              d="M605.278 609.87C605.278 621.672 595.71 631.24 583.908 631.24C572.106 631.24 562.538 621.672 562.538 609.87C562.538 598.068 572.106 588.5 583.908 588.5C595.71 588.5 605.278 598.068 605.278 609.87Z"
              fill="#E04F6F" stroke="white" />
            <path
              d="M604.617 672.141L604.274 672.343L604.394 672.722L620.801 724.842L620.809 724.868L620.82 724.893C622.6 728.954 619.624 733.507 615.19 733.507H606.002C605.1 733.507 604.371 734.238 604.371 735.138V776.603C604.371 781.882 600.092 786.161 594.813 786.161C589.534 786.161 585.255 781.882 585.255 776.603V734.849C585.255 734.109 584.655 733.508 583.914 733.508H582.995C582.255 733.508 581.654 734.108 581.654 734.849V776.603C581.654 781.882 577.375 786.161 572.096 786.161C566.817 786.161 562.538 781.882 562.538 776.603V735.138C562.538 734.237 561.807 733.507 560.907 733.507H551.719C547.283 733.507 544.309 728.955 546.089 724.893L546.1 724.868L546.108 724.842L562.515 672.722L562.634 672.343L562.291 672.141C562.272 672.13 562.265 672.126 562.258 672.122L562.236 672.109L561.772 671.836L561.534 672.319L547.758 700.306C545.926 704.027 541.426 705.556 537.705 703.724L537.701 703.722L537.699 703.721C533.974 701.887 532.441 697.381 534.274 693.656L552.457 656.717L552.458 656.715L558.635 644.047L558.186 643.828L558.635 644.047C560.907 639.387 565.638 636.431 570.823 636.431H583.439H583.47H596.086C601.271 636.431 606.001 639.387 608.273 644.047L608.723 643.828L608.273 644.047L614.45 656.715L614.451 656.717L632.634 693.656C634.468 697.381 632.934 701.887 629.21 703.721L629.207 703.722L629.204 703.724C629.204 703.724 629.203 703.724 629.203 703.724C625.482 705.555 620.982 704.027 619.15 700.306L605.374 672.319L605.136 671.836L604.672 672.109L604.65 672.122C604.648 672.124 604.645 672.125 604.641 672.127C604.636 672.13 604.629 672.134 604.617 672.141Z"
              fill="#E04F6F" stroke="white" />
            <rect x="1039" y="677" width="12" height="52" fill="#3E4D57" />
          </svg>
          <div class="my-card__title">Tier 1</div>
        </div>
        <ul>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Personal listing FAQ
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Additional Category Tag
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Must try item recommendation
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Listing maintenance
            </div>
          </li>
        </ul>
        <div class="my-card__footer">
          <div class="amount">$59 <span>/ Month</span></div>
          <div class="name-amount">(Home businesses)</div>
          <button class="my-button-3 mt-4 secondary" (click)="handleSubscribe('SUPER_SELLER_1')">Buy now</button>
        </div>
      </div>
      <div class="my-card lg space-b">
        <div>
          <img loading="lazy" src="../../../../../../assets/images/icon-price.png" alt="" />
          <div class="my-card__title">Tier 2</div>
        </div>
        <ul>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Everything in Tier 1
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Personal message/ intro video
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Telegram area shoutouts x1/mth
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Promotional updates
            </div>
          </li>
        </ul>
        <div class="my-card__footer">
          <div class="amount">$ 99<span>/ Month</span></div>
          <div class="name-amount">(Other Services)</div>
          <button class="my-button-3 mt-4 secondary" (click)="handleSubscribe('SUPER_SELLER_2')">Buy now</button>
        </div>
      </div>
      <div class="my-card space-b">
        <div>
          <img loading="lazy" src="../../../../../../assets/images/icon-price-2.png" alt="" />
          <div class="my-card__title">Tier 3</div>
        </div>
        <ul>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Everything in Tier 1 and Tier 2
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              1 Recommendation articles
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Personal listing store
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Survey info, pre and post survey for improvement
            </div>
          </li>
          <li>
            <div class="item">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              Telegram area shoutouts x2/mth
            </div>
          </li>
          <!-- <li>
            <div class="item" (click)="showList = !showList">
              <div class="icon"><i class="fa-solid fa-check"></i></div>
              <div>
                Super Seller Role Unlocked
                <i class="fa-chevron-down fa-solid"></i>
              </div>
            </div>
            <div class="sub-list" [class.active]="showList">
              <div class="sub-list__item">- Calendar Feature</div>
              <div class="sub-list__item">- More Products</div>
              <div class="sub-list__item">- Socials</div>
              <div class="sub-list__item">- Attach product</div>
              <div class="sub-list__item">- Discuss</div>
              <div class="sub-list__item">- Rent Deposit Function</div>
            </div>
          </li> -->
        </ul>
        <div class="my-card__footer">
          <div class="amount">$ 199<span>/ Month</span></div>
          <button class="my-button-3 mt-4 secondary" (click)="handleSubscribe('SUPER_SELLER_3')">Buy now</button>
        </div>
      </div>
    </div>
    <br />
    <br />
    <div class="header">
      <div class="text-left w-100">
        <div class="d-flex justify-content-between">
          <h2>PURCHASE DIAMONDS</h2>
          <div class="current-diamonds">
            <div class="diamond-icon">
              <i class="fa-solid fa-gem"></i>
            </div>
            <div class="diamond-info">
              <div class="amount">{{ userInfo?.diamonds || 0 }}</div>
            </div>
          </div>
        </div>
        <div class="desc">Diamonds are for in-store items and upgrades. There is no refund provided for purchases,
          please contact Help Center if you need help.</div>
      </div>
    </div>
    <div class="my-grid">
      <ng-container *ngIf="userInfo?.level < 5">
        <div class="not-allowed">You have to be level 5 and above to subscribe or purchase tokens</div>
      </ng-container>
      <div class="my-card">
        <div class="bg-icon">
          <svg viewBox="0 0 585 474" fill="none">
            <path
              d="M267.465 0H109.258C107.461 0 105.845 1.15 105.119 2.953C104.38 4.751 104.677 6.839 105.863 8.315L184.406 105.359C185.277 106.424 186.488 107.03 187.795 107.036C189.102 107.042 190.312 106.449 191.19 105.389L270.841 8.345C272.039 6.874 272.354 4.774 271.616 2.965C270.89 1.162 269.256 0 267.465 0Z" />
            <path
              d="M179.988 127.698H18.1804C16.3894 127.698 14.7794 128.836 14.0414 130.621C13.3024 132.407 13.5694 134.483 14.7374 135.971L259.076 445.758C260.474 447.537 262.817 448.01 264.675 446.878C266.563 445.746 267.477 443.338 266.878 441.08L184.364 131.293C183.777 129.163 182.004 127.698 179.988 127.698Z" />
            <path
              d="M475.353 0.00488281H310.906C309.078 0.00488281 307.444 1.18588 306.718 3.03088C306.017 4.87688 306.343 6.99488 307.602 8.44788L391.944 105.71C392.828 106.708 394.05 107.277 395.309 107.259C396.604 107.235 397.796 106.624 398.649 105.589C414.542 85.9739 457.777 32.7949 478.675 8.42886C479.904 6.97086 480.249 4.84586 479.541 3.01886C478.803 1.18586 477.168 0.00488281 475.353 0.00488281Z" />
            <path
              d="M571.182 127.747H402.813C400.756 127.747 398.976 129.266 398.425 131.433L320.88 443.241C320.317 445.498 321.243 447.87 323.119 448.972C325.007 450.079 327.32 449.601 328.717 447.834L574.619 136.02C575.793 134.549 576.059 132.455 575.309 130.676C574.583 128.89 572.979 127.747 571.182 127.747Z" />
            <path
              d="M289.033 7.80591C287.774 7.81791 286.564 8.41789 285.717 9.45789L205.588 107.072C204.389 108.536 204.075 110.649 204.801 112.446C205.54 114.249 207.162 115.411 208.971 115.411H373.75C375.578 115.411 377.212 114.225 377.938 112.385C378.646 110.533 378.301 108.421 377.042 106.968L292.398 9.35392C291.521 8.34592 290.304 7.78191 289.033 7.80591Z"
              class="grey" />
            <path
              d="M495.059 7.80591C493.782 7.81791 492.589 8.41789 491.718 9.45789L411.601 107.072C410.384 108.536 410.1 110.649 410.814 112.446C411.553 114.249 413.175 115.411 414.978 115.411H579.763C581.585 115.411 583.225 114.225 583.927 112.385C584.671 110.533 584.308 108.421 583.067 106.968L498.411 9.35392C497.528 8.34592 496.317 7.78191 495.059 7.80591Z"
              class="grey" />
            <path
              d="M84.6316 7.80591C83.3606 7.81791 82.1626 8.41789 81.3146 9.45789L1.17357 107.072C-0.0364274 108.536 -0.339421 110.649 0.398579 112.446C1.12458 114.249 2.75956 115.411 4.55056 115.411H169.318C171.164 115.411 172.798 114.225 173.525 112.385C174.245 110.533 173.882 108.421 172.623 106.968L87.9846 9.35392C87.1196 8.34592 85.9026 7.78191 84.6316 7.80591Z"
              class="grey" />
            <path
              d="M204.996 128.364C203.561 128.364 202.206 129.114 201.34 130.367C200.475 131.62 200.208 133.266 200.614 134.773L289.882 469.906C290.451 472.06 292.279 473.525 294.288 473.507C296.334 473.495 298.113 471.97 298.645 469.828L381.982 134.689C382.357 133.188 382.061 131.572 381.232 130.331C380.361 129.097 379.011 128.365 377.595 128.365H204.996V128.364Z" />
          </svg>
        </div>
        <div class="price"><span>$</span> 10</div>
        <div class="amount">100<span>Diamonds</span></div>
        <button class="my-button-3" (click)="handleSubscribe('DIAMOND_1')">Buy Now</button>
      </div>
      <div class="my-card lg">
        <div class="bg-icon">
          <svg viewBox="0 0 585 474" fill="none">
            <path
              d="M267.465 0H109.258C107.461 0 105.845 1.15 105.119 2.953C104.38 4.751 104.677 6.839 105.863 8.315L184.406 105.359C185.277 106.424 186.488 107.03 187.795 107.036C189.102 107.042 190.312 106.449 191.19 105.389L270.841 8.345C272.039 6.874 272.354 4.774 271.616 2.965C270.89 1.162 269.256 0 267.465 0Z" />
            <path
              d="M179.988 127.698H18.1804C16.3894 127.698 14.7794 128.836 14.0414 130.621C13.3024 132.407 13.5694 134.483 14.7374 135.971L259.076 445.758C260.474 447.537 262.817 448.01 264.675 446.878C266.563 445.746 267.477 443.338 266.878 441.08L184.364 131.293C183.777 129.163 182.004 127.698 179.988 127.698Z" />
            <path
              d="M475.353 0.00488281H310.906C309.078 0.00488281 307.444 1.18588 306.718 3.03088C306.017 4.87688 306.343 6.99488 307.602 8.44788L391.944 105.71C392.828 106.708 394.05 107.277 395.309 107.259C396.604 107.235 397.796 106.624 398.649 105.589C414.542 85.9739 457.777 32.7949 478.675 8.42886C479.904 6.97086 480.249 4.84586 479.541 3.01886C478.803 1.18586 477.168 0.00488281 475.353 0.00488281Z" />
            <path
              d="M571.182 127.747H402.813C400.756 127.747 398.976 129.266 398.425 131.433L320.88 443.241C320.317 445.498 321.243 447.87 323.119 448.972C325.007 450.079 327.32 449.601 328.717 447.834L574.619 136.02C575.793 134.549 576.059 132.455 575.309 130.676C574.583 128.89 572.979 127.747 571.182 127.747Z" />
            <path
              d="M289.033 7.80591C287.774 7.81791 286.564 8.41789 285.717 9.45789L205.588 107.072C204.389 108.536 204.075 110.649 204.801 112.446C205.54 114.249 207.162 115.411 208.971 115.411H373.75C375.578 115.411 377.212 114.225 377.938 112.385C378.646 110.533 378.301 108.421 377.042 106.968L292.398 9.35392C291.521 8.34592 290.304 7.78191 289.033 7.80591Z"
              class="grey" />
            <path
              d="M495.059 7.80591C493.782 7.81791 492.589 8.41789 491.718 9.45789L411.601 107.072C410.384 108.536 410.1 110.649 410.814 112.446C411.553 114.249 413.175 115.411 414.978 115.411H579.763C581.585 115.411 583.225 114.225 583.927 112.385C584.671 110.533 584.308 108.421 583.067 106.968L498.411 9.35392C497.528 8.34592 496.317 7.78191 495.059 7.80591Z"
              class="grey" />
            <path
              d="M84.6316 7.80591C83.3606 7.81791 82.1626 8.41789 81.3146 9.45789L1.17357 107.072C-0.0364274 108.536 -0.339421 110.649 0.398579 112.446C1.12458 114.249 2.75956 115.411 4.55056 115.411H169.318C171.164 115.411 172.798 114.225 173.525 112.385C174.245 110.533 173.882 108.421 172.623 106.968L87.9846 9.35392C87.1196 8.34592 85.9026 7.78191 84.6316 7.80591Z"
              class="grey" />
            <path
              d="M204.996 128.364C203.561 128.364 202.206 129.114 201.34 130.367C200.475 131.62 200.208 133.266 200.614 134.773L289.882 469.906C290.451 472.06 292.279 473.525 294.288 473.507C296.334 473.495 298.113 471.97 298.645 469.828L381.982 134.689C382.357 133.188 382.061 131.572 381.232 130.331C380.361 129.097 379.011 128.365 377.595 128.365H204.996V128.364Z" />
          </svg>
        </div>
        <div class="price"><span>$</span> 50</div>
        <div class="amount">600<span>Diamonds</span></div>
        <div class="save_info">SAVE 20%</div>
        <button class="my-button-3" (click)="handleSubscribe('DIAMOND_2')">Buy Now</button>
      </div>
      <div class="my-card">
        <div class="bg-icon">
          <svg viewBox="0 0 585 474" fill="none">
            <path
              d="M267.465 0H109.258C107.461 0 105.845 1.15 105.119 2.953C104.38 4.751 104.677 6.839 105.863 8.315L184.406 105.359C185.277 106.424 186.488 107.03 187.795 107.036C189.102 107.042 190.312 106.449 191.19 105.389L270.841 8.345C272.039 6.874 272.354 4.774 271.616 2.965C270.89 1.162 269.256 0 267.465 0Z" />
            <path
              d="M179.988 127.698H18.1804C16.3894 127.698 14.7794 128.836 14.0414 130.621C13.3024 132.407 13.5694 134.483 14.7374 135.971L259.076 445.758C260.474 447.537 262.817 448.01 264.675 446.878C266.563 445.746 267.477 443.338 266.878 441.08L184.364 131.293C183.777 129.163 182.004 127.698 179.988 127.698Z" />
            <path
              d="M475.353 0.00488281H310.906C309.078 0.00488281 307.444 1.18588 306.718 3.03088C306.017 4.87688 306.343 6.99488 307.602 8.44788L391.944 105.71C392.828 106.708 394.05 107.277 395.309 107.259C396.604 107.235 397.796 106.624 398.649 105.589C414.542 85.9739 457.777 32.7949 478.675 8.42886C479.904 6.97086 480.249 4.84586 479.541 3.01886C478.803 1.18586 477.168 0.00488281 475.353 0.00488281Z" />
            <path
              d="M571.182 127.747H402.813C400.756 127.747 398.976 129.266 398.425 131.433L320.88 443.241C320.317 445.498 321.243 447.87 323.119 448.972C325.007 450.079 327.32 449.601 328.717 447.834L574.619 136.02C575.793 134.549 576.059 132.455 575.309 130.676C574.583 128.89 572.979 127.747 571.182 127.747Z" />
            <path
              d="M289.033 7.80591C287.774 7.81791 286.564 8.41789 285.717 9.45789L205.588 107.072C204.389 108.536 204.075 110.649 204.801 112.446C205.54 114.249 207.162 115.411 208.971 115.411H373.75C375.578 115.411 377.212 114.225 377.938 112.385C378.646 110.533 378.301 108.421 377.042 106.968L292.398 9.35392C291.521 8.34592 290.304 7.78191 289.033 7.80591Z"
              class="grey" />
            <path
              d="M495.059 7.80591C493.782 7.81791 492.589 8.41789 491.718 9.45789L411.601 107.072C410.384 108.536 410.1 110.649 410.814 112.446C411.553 114.249 413.175 115.411 414.978 115.411H579.763C581.585 115.411 583.225 114.225 583.927 112.385C584.671 110.533 584.308 108.421 583.067 106.968L498.411 9.35392C497.528 8.34592 496.317 7.78191 495.059 7.80591Z"
              class="grey" />
            <path
              d="M84.6316 7.80591C83.3606 7.81791 82.1626 8.41789 81.3146 9.45789L1.17357 107.072C-0.0364274 108.536 -0.339421 110.649 0.398579 112.446C1.12458 114.249 2.75956 115.411 4.55056 115.411H169.318C171.164 115.411 172.798 114.225 173.525 112.385C174.245 110.533 173.882 108.421 172.623 106.968L87.9846 9.35392C87.1196 8.34592 85.9026 7.78191 84.6316 7.80591Z"
              class="grey" />
            <path
              d="M204.996 128.364C203.561 128.364 202.206 129.114 201.34 130.367C200.475 131.62 200.208 133.266 200.614 134.773L289.882 469.906C290.451 472.06 292.279 473.525 294.288 473.507C296.334 473.495 298.113 471.97 298.645 469.828L381.982 134.689C382.357 133.188 382.061 131.572 381.232 130.331C380.361 129.097 379.011 128.365 377.595 128.365H204.996V128.364Z" />
          </svg>
        </div>
        <div class="price"><span>$</span> 100</div>
        <div class="amount">1300<span>Diamonds</span></div>
        <div class="save_info">SAVE 30%</div>
        <button class="my-button-3" (click)="handleSubscribe('DIAMOND_3')">Buy Now</button>
      </div>
    </div>
  </div>
</div>